
<div
  v-if="produit"
  :class="[
    jel_getClassObject(content),
    { 'produit-desactive': produitDesactivation && produitDesactivation.indDesactive },
  ]"
  class="cursor-pointer info-produit"
  @click="jel_forcerClickHyperlien(refRedirection)"
>
  <b-link
    :ref="refRedirection"
    v-bind="jel_getLienBinding(mixinProduitCasino_getLienPageProduit())"
    class="d-none"
  >
    <!-- conserver pour accessibilité -->
    invisible
  </b-link>
  <div
    v-if="isVisible"
    class="d-flex flex-row position-relative align-items-center produit-casino w-100"
  >
    <b-row class="w-100 mx-auto">
      <b-col :cols="jel_isCarteLarge(content) ? 2 : 3" class="px-0 my-auto">
        <div class="disabled-overlay"></div>
        <MediaImageLogo :content="contentMediaImageLogo" class="image-produit" />
      </b-col>
      <b-col
        :cols="jel_isCarteLarge(content) ? 10 : 9"
        class="d-flex flex-row justify-content-between align-items-center w-100 pl-1"
      >
        <b-container class="p-0">
          <b-row>
            <b-col :cols="jel_isCarteLarge(content) ? 9 : 8" class="pr-1">
              <div class="titre-jeu graphik_bold" v-html="mixinProduitCasino_getTitre()" />
              <div v-if="isLotProgressif && !isProduitDesactive" class="d-flex align-items-end">
                <span v-if="mntProgressif" class="lot-progressif graphik_bold">
                  {{ formatMontantProgressif }}
                </span>
                <span v-else class="progressif-multiple graphik_regular">
                  {{ $i18n.tc('messageComponent.progressif', nbProgressif) }}
                </span>
                <span
                  v-if="nbProgressif > 1 && (jel_isCarteLarge(content) || !mntProgressif)"
                  class="progressif-multiple progressif-multiple-large"
                  >{{ $i18n.tc('messageComponent.progressif', nbProgressif) }}</span
                >
              </div>
              <div
                class="mise-jeu graphik_regular font-weight-normal"
                v-html="mixinProduitCasino_getMiseMinMax()"
              />
            </b-col>
            <b-col
              :cols="jel_isCarteLarge(content) ? 3 : 4"
              class="d-flex align-items-center px-0"
            >
              <Hyperlien
                :aria-label="mixinProduitCasino_getTitre(false)"
                :content="{
                  texte: getTexteBoutonJouer,
                  theme: 'themeClair',
                  type: 'boutonPrimaire',
                  classeCSS: 'd-flex justify-content-end w-100',
                  lien: mixinProduitCasino_getLienPageProduit('mode=lancer'),
                }"
              />
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </div>
  <div
    v-else
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
    }"
    class="chargement"
  >
    <span>{{ mixinProduitCasino_getTitre(false) }}...</span>
  </div>
</div>
